"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function initialState() {
  return {
    "class": 'claim',
    type: null,
    // 'secured', 'unsecured_priority', 'unsecured_nonpriority'
    // ALL --
    subType: null,
    // 'mortgage', 'statutory', 'judgment', 'education', 'auto', 'other'
    subTypeOtherDescription: null,
    creditor: null,
    // party
    accountNumber: null,
    interest: null,
    // 'debtor_1', 'debtor_2', 'both', 'one_and_another'
    community: null,
    date: null,
    isContingent: false,
    isDisputed: false,
    isUnliquidated: false,
    offset: false,
    codebtors: [],
    // [party]
    value: 0,
    // Secured --
    valueCollateral: null,
    valueUnsecured: null,
    lienAgreement: false,
    lienStatutory: false,
    lienJudgment: false,
    lienOther: false,
    otherLeinDescription: null,
    exempt: false,
    isSurrendering: false,
    isRetainRedeem: false,
    isRetainReaffirm: false,
    isRetainOther: null,
    isRetainOtherDescription: null,
    assetDescription: null,
    // In the event of reposessions
    // Unsecured --
    notify: [],
    // [party] - collection agencies
    // Unsecured Priority --
    valuePriority: null,
    // NOTE: type === 'unsecured_priority'
    valueNonPriority: null,
    // NOTE: type === 'unsecured_priority'
    // Extras --
    status: null,
    // 'open', 'closed'
    additionalDescription: null,
    // For storing comments about ownership transfers
    source: null // Is it from docassemble interview or directly from meridian?

  };
}

var createClaim = function createClaim(attrs) {
  return _objectSpread({}, initialState(), {}, attrs, {
    id: (0, _v["default"])()
  });
};

var _default = createClaim;
exports["default"] = _default;